import { dispatchShowAlert } from './alerts';

/**
 * One calm confirmation after account deletion. The deletion flow restarts the
 * app on its signed-out landing (a full reload), so the message rides across it
 * in sessionStorage and is shown once, on the first page that loads.
 */
const KEY = 'ras:accountDeleted';

export function markAccountDeleted(): void {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    // Private mode / blocked storage: the restart still happens, just no notice.
  }
}

export function showAccountDeletedNotice(): void {
  let deleted = false;
  try {
    deleted = sessionStorage.getItem(KEY) === '1';
    sessionStorage.removeItem(KEY);
  } catch {
    return;
  }

  if (deleted) {
    // Alerts are fire-and-forget events, and this runs in the layout's first
    // effect, before the alert list has mounted its listener on a cold boot.
    // Give the app a moment to settle so the notice isn't dropped.
    window.setTimeout(() => {
      dispatchShowAlert({
        id: 'account_deleted',
        status: 'success',
        message: 'Your account has been deleted.',
      });
    }, 800);
  }
}
